import React, { useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { FormTextarea, Button } from '@/components/ui';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, role, loading = false }) => {
  const [notes, setNotes] = useState('');

  const handleAction = (status) => {
    onConfirm({ status, notes });
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-slate-900"
                >
                  {role} Approval
                </Dialog.Title>
                <div className="mt-2 mb-4">
                  <p className="text-sm text-slate-500">
                    Review the design and provide your approval or rejection as <strong>{role}</strong>.
                  </p>
                </div>

                <div className="mt-4">
                  <FormTextarea
                    label="Notes"
                    placeholder="Enter any comments or reasons..."
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    rows={3}
                  />
                </div>

                <div className="mt-6 flex justify-end gap-3">
                  <Button
                    variant="secondary"
                    onClick={onClose}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => handleAction('rejected')}
                    loading={loading}
                  >
                    Reject
                  </Button>
                  <Button
                    variant="primary"
                    className="bg-green-600 hover:bg-green-700 text-white"
                    onClick={() => handleAction('approved')}
                    loading={loading}
                  >
                    Approve
                  </Button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ConfirmationModal;